"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var AppMargins_1 = require("./AppMargins");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        backgroundType: {
            width: '100%',
            backgroundColor: function (props) {
                switch (props.backgroundType) {
                    case 'light':
                        return theme.palette.background.paper;
                    case 'dark':
                        return theme.palette.background.default;
                    case 'darkest':
                        return theme.palette.primary.dark;
                    case 'black':
                        return '#000000';
                    default:
                        return props.backgroundType;
                }
            },
            boxShadow: function (props) {
                return props.shadow ? '0px 1px 1px rgba(216, 216, 216, 0.5)' : '0';
            },
            '@media screen\\0': {
                minHeight: '1px',
            },
        },
        childrenPadding: {
            paddingTop: function (props) {
                return theme.spacing(8 * props.verticalMultiplier * props.topMultiplier);
            },
            paddingBottom: function (props) {
                return theme.spacing(8 * props.verticalMultiplier * props.bottomMultiplier);
            },
        },
    });
});
var Section = function (_a) {
    var children = _a.children, _b = _a.backgroundType, backgroundType = _b === void 0 ? '' : _b, _c = _a.verticalMultiplier, verticalMultiplier = _c === void 0 ? 1 : _c, _d = _a.topMultiplier, topMultiplier = _d === void 0 ? 1 : _d, _e = _a.bottomMultiplier, bottomMultiplier = _e === void 0 ? 1 : _e, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.shadow, shadow = _g === void 0 ? false : _g;
    var classes = useStyles({
        backgroundType: backgroundType,
        verticalMultiplier: verticalMultiplier,
        topMultiplier: topMultiplier,
        bottomMultiplier: bottomMultiplier,
        shadow: shadow,
    });
    return (react_1.default.createElement("div", { className: "".concat(className, " ").concat(classes.backgroundType) },
        react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
            react_1.default.createElement("div", { className: classes.childrenPadding }, children))));
};
Section.defaultProps = {
    backgroundType: 'light',
    verticalMultiplier: 1,
    topMultiplier: 1,
    bottomMultiplier: 1,
};
exports.default = Section;
